<script>
    import R, {LOADER} from "../lib/requests";
    import {CHECKIN_STATUS} from "../lib/constants.js";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import CheckInData from "./CheckInData.svelte";
    import CheckinPerson from "./CheckinPerson.svelte";

    export let checkinId;

    let checkin = null;
    let hotel = null;
    let errorMessage = null;

    const breadcrumb = [
        {id: 'checkins', name: 'Check Ins', link: `/app/checkins`}
    ];

    const load = () => {
        const onSuccess = result => {
            checkin = result;
            hotel = checkin.hotel;
        }

        const onFailure = err => {
            errorMessage = "check in not found!";
        };

        R.handle(R.checkin.details, checkinId, onSuccess, onFailure, LOADER.PAGE);
    }

    load();
</script>

<Breadcrumb {breadcrumb}/>
<PageHeader title="User Check in Details"/>
{#if checkin}
    <h2 class="mb-2">{ hotel.name }</h2>
    <div class="row">
        <div class="col-xl-6 col-lg-10 col-md-12">

            <div class="panel-simple panel-pad mb-4">
                <div class="row">
                    <div class="col-xl-3 col-lg-4 col-md-4 col-6">
                        <span class="fw-bold">Check in:</span>
                        { checkin.date_in }
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-4 col-6">
                        <span class="fw-bold">Check out:</span>
                        { checkin.date_out }
                    </div>
                </div>
            </div>

            {#each checkin.persons as person, index}
                <CheckinPerson {person} {index}/>
            {/each}
        </div>
    </div>
{/if}
{#if errorMessage}
    <PageNotFound message="{ errorMessage }"/>
{/if}
